import * as React from 'react';
// import {markdown} from 'markdown';
import AppView from '~common/components/app-view/index';
import { withStyles, WithStyles, StyleRules } from '@material-ui/core/styles';
import LoadingView from '../components/loading-view';
import { Definition, PredefinedField } from '../lib/types';
import DefinitionFormController from './definition-form-controller';
// import {buildSectionTitle} from './helper';
import { Theme } from '@material-ui/core/styles';
import { Grid ,Typography, IconButton, FormHelperText,} from '@material-ui/core';
import { Field } from '../components/form-def-field';
import {markdown} from 'markdown';
import EmptySet from '../components/empty-set';
import Pager from '../components/query-fulfillment/query-list-pager';
import CookieManager from '~common/lib/cookie-manager';
import {IconButton as ConfirmButton} from '~common/components/confirmation-button';
import { times } from 'lodash';
import fieldEditView from './field-edit-view';

const styles = (theme: Theme): StyleRules => {
  let selectionColor = 'orange';
  if (
    theme.overrides &&
    theme.overrides.MuiButton &&
    theme.overrides.MuiButton.containedPrimary &&
    theme.overrides.MuiButton.containedPrimary.backgroundColor
  ) {
    selectionColor = theme.overrides.MuiButton.containedPrimary.backgroundColor;
  }

  return {
    container: {
      width: '100%',
      paddingTop: 5,
      paddingBottom: 15
    },
    errorInstructions: {
      // padding: 15,
      paddingLeft: 15,
      fontSize: '1rem',
      color: '#f44336'
    },
    warnInstructions: {
      // padding: 15,
      paddingLeft: 15,
      fontSize: '1rem',
      color: '#ffae42'
    },
    historyInstructions: {
      padding: 15,
      fontSize: '1rem',
      color: '#1614b3'
    },
    fullScreen: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundColor: '#fff',
      zIndex: 1000
    },
    sectionTitle: {
      marginTop: 15,
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    subSectionTitle: {
      marginTop: 15,
      paddingBottom: 0,
      paddingLeft: 15,
      // borderBottom: "1px solid black",
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Roboto,Arial,sans-serif;',
      fontSize: '1.15rem',
      fontWeight: 500,
      color: '#555',
      margin: '15px 0'
    },
    fieldArea: {
      display: 'flex',
      //flexDirection: "row-reverse",
      alignItems: 'center',
      marginTop: 0,
      paddingTop: 0,
    },
    formArea: {
      paddingLeft: 5,
      paddingRight: 5
    },
    formAreaOutdent: {
      paddingTop: 0,
      // paddingLeft: -20,
      marginLeft: 10,
      borderBottom: "1px solid #dedede",
      marginBottom: 5,
      paddingBottom: 10,
      width: "100%"
      // marginRight: -150
      // paddingRight: -150

    },
    sectionArea: {
      display: 'flex',
      //flexDirection: "row-reverse",
      alignItems: 'baseline'
    },
    instructions: {
      padding: '0px 15px 15px 15px',
      fontSize: '1rem',
      // color: '#303030'
    },
    noInstructions: {
      padding: '5px 15px 15px 15px',
      fontSize: '1rem',
      // color: '#303030'
    },
    item: {
      display: 'flex',
      alignItems: 'baseline',
      padding: 15
    },
    itemOdd: {},
    itemEven: {
      backgroundColor: '#eaeaea'
    },
    itemActionBar: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: 5,
      paddingLeft: 15,
      marginBottom: -15
    },
    singleItemActionBar: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: 5,
      paddingLeft: -5,
      marginBottom: -15
    }, 
    itemAdd: {
      marginTop: 20
    },
    itemSingle: {},
    itemDelete: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.90rem',
      width: 30,
      height: 30
    },
    successIcon: {
      color: 'green',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    infoIcon: {
      color: '#005897',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    warnIcon: {
      color: 'gold',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    errorIcon: {
      color: '#f44336',
      fontSize: '0.9rem',
      paddingRight: 5
    },
    selectedRow: {
      border: '1px solid ' + selectionColor,
      margin: 1,
      position: 'relative',
      '&::before': {
        content: 'x',
        display: 'block',
        width: 20,
        height: 20,
        float: 'left',
        margin: '0 6px 0 0'
      }
    },
    unselectedRow: {
      border: '1px solid rgba(255,255,255,0.0)',
      margin: 1,
      position: 'relative',
      '&::before': {
        content: 'o',
        display: 'block',
        width: 20,
        height: 20,
        float: 'left',
        margin: '0 6px 0 0'
      }
    },
    unselectableRow: {
      border: '0px solid rgba(255,255,255,0.0)',
      margin: 1,
      position: 'relative'
    },
    selectionActionArea: {
      display: 'flex',
      justifyContent: 'flex-start', //'space-between' has the effect of pushing the selection count text to the right.
      textAlign: 'right',
      paddingLeft: 6,
      paddingRight: 5,
      paddingBottom: 5,
      verticalAlign: 'baseline',
      minHeight: 45,
      marginBottom: 5,
      fontSize: "0.85rem"
    },
    selectionCount: {
      display: 'inline-block',
      textAlign: 'left',
      paddingTop: 10
    },
    selectionAction: {
      display: 'inline-block',
      width: '30%'
    },
    allSelectors: {
      display: 'flex',
      color: '#333',
      textAlign: 'left',
      paddingTop: 10,
      paddingRight: 15
    },
    selectAll: {
      color: selectionColor,
      display: 'inline-block',
      cursor: 'pointer',
      padding: "0px 0px 0px 0px"
    },
    unselectAll: {
      color: selectionColor,
      display: 'inline-block',
      cursor: 'pointer',
      padding: "0px 30px"
    },
    selector: {
      color: selectionColor
    },
    select: {
      position: "absolute",
      top: 0,
      left: 0,
      width: 30,
      height: 30,
      zIndex: 20,
      color: selectionColor,
      display: 'inline-block',
      cursor: 'pointer'
    },
    unselect: {
      position: "absolute",
      top: 0,
      left: 0,
      width: 30,
      height: 30,
      zIndex: 20,
      color: selectionColor,
      display: 'inline-block',
      cursor: 'pointer'
    },
    overlay: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255,255,255,0.5)',
      zIndex: 10,
      cursor: 'pointer'
    }
  };
};

interface Props extends React.HTMLProps<HTMLDivElement> {
  path: string;
  data: any;
  definition: Definition;
  itemRenderer: (i: any, idx: number) => any;
  policyMessages?: Array<any>;
  adminMode?: boolean;
  sectionConfigIcon?: any;
  emptySetRenderers?: any;
  singleRecordSelector?: string
  readOnly?: boolean;
  onChangeAtPath: (path: string, newVal: any) => void;
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  data: any;
  status: 'ready' | 'loading';

  // Applying attributes below allow us to use a full-screen form to apply data at a given path.  This is frequestly use to spawn children.
  multiEditPath?: string;
  multiEditIdx?: number;

  // if using paging
  currentPage: number;
  pageSize: number;

  // the currently showing record index when the singleRecordViewer is active. 
  singleRecordIdx: number;
  // Typography of the single record viewer section
  singleRecordTitle: string;
};

class FormItemList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
  > {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    // check for pageSize cookie
    var pageSize: any = 10;
    var ps = CookieManager.getCookie(
      `definitionPageSize|${window.location.pathname}`
    );
    if (ps != '') {
      pageSize = Number(ps);
      if (isNaN(pageSize)) {
        pageSize = undefined;
      }
    }

    this.state = {
      data: props.data || [],
      status: 'loading',
      pageSize: pageSize,
      singleRecordIdx: 0,
      currentPage: 0
    };
  }

  getPolicyMessageClass = (policyMessage: any) => {
    const {classes}: {classes: any} = this.props;
    switch (policyMessage.severity) {
      case 1:
        return classes.warnInstructions
      case 2:
        return classes.errorInstructions
      case 4:
        return classes.historyInstructions
      default:
        return undefined
    }
  }

  componentDidMount() {
    const { definition, path, onChangeAtPath } = this.props;
    const { data, pageSize } = this.state;
    let needsUpdate = false;
    // Initiate loading here is any loading is required.  Do not forget to also implement in componentWillReceiveProps also
    if (definition) {
      if (definition.primedMultiples) {
        while (data.length < definition.primedMultiples) {
          data.push({});
          needsUpdate = true;
        }
      }
    }

    var ps = CookieManager.getCookie(`definitionPageSize|${definition.key}`);
    if (ps != '') {
      pageSize = Number(ps);
      if (isNaN(pageSize)) {
        pageSize = undefined;
      }
    }
    
    var label = ""
    if (this.props.singleRecordSelector) {
      label = this.getSingleRecordLabel(0)
    }

    this.setState({
      data: data,
      status: 'ready',
      pageSize: pageSize,
      singleRecordTitle: label,
      currentPage: 0
    });

    if (needsUpdate) {
      if (onChangeAtPath) {
        onChangeAtPath(path, data);
      }
    }
  }

  componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>,
    oldProps: Props & WithStyles<keyof typeof styles>
  ) {
    const { singleRecordIdx, singleRecordTitle } = this.state;
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement in componentDidMount also
    if (newProps.policyMessages) {
    }


    var newTitle = singleRecordTitle
    if (newProps.data && newProps.data[singleRecordIdx] && newProps.data[singleRecordIdx][newProps.singleRecordSelector]){
      newTitle = this.getSingleRecordLabel(singleRecordIdx)
    }
    this.setState({ data: newProps.data, status: 'ready', singleRecordTitle: newTitle });
  }

  handleRowClick = (row: any) => () => {
    if (this.props.onRowClick) {
      this.props.onRowClick.call(this, row);
    }
  };

  handleChangePage = (newPage: number, newPageSize: number) => {
    const { pageSize } = this.state;
    if (pageSize != newPageSize) {
      // if the page size is changed, go back to page 1
      newPage = 0;
    }

    this.setState({ currentPage: newPage, pageSize: newPageSize }, () => {
      // save pageSize to cookie
      CookieManager.setCookie(
        `queryListPageSize|${window.location.pathname}`,
        String(newPageSize),
        30
      );
    });
  };

  // handleChangeAtPath is used to ferry changes from owned omponents upstream
  handleChangeAtPath = (path: string, val: any) => {
    this.props.onChangeAtPath(path, val);
  };

  handleItemDelete = (idx: number) => (evt: any) => {
    const { data, currentPage, pageSize } = this.state;
    const { path, onChangeAtPath, definition } = this.props;

    var newData: Array<any> = data.filter(function (value, arrIndex) {
      return idx !== arrIndex;
    });


    const maxPage = Math.floor(data.length / pageSize)
    if (currentPage > maxPage) {
      currentPage = maxPage
    }

    this.setState({ data: newData, currentPage: currentPage });
    // Also reset the whole collection

    // check the field definitions for the _deleted field.
    // can be used to trigger a validation when a line is deleted
    var fieldDef: any
    if (definition) {
      for (let preDefined of definition.predefined) {
        if (preDefined.key == "_deleted") {
          fieldDef = preDefined
        }
      }
      
      if (!fieldDef) {
        fieldDef = definition.user["_deleted"]
      }
    }

    if (this.props.handleItemDelete) {
      this.props.handleItemDelete(idx, path, newData, fieldDef)
    } else {
      onChangeAtPath(path, newData, fieldDef);
    }

    evt.stopPropagation()
    evt.preventDefault()
  };

  handleItemEdit = (idx: number) => () => {
    const { data } = this.state;
    const { path } = this.props;

    var editItem = data[idx];
    if (editItem) {
      const targetPath = path + '/' + idx;
      this.setState({ multiEditPath: targetPath, multiEditIdx: idx });
    }
  };

  handleItemAdd = () => {
    const { data, pageSize } = this.state;
    const { definition, path, onChangeAtPath } = this.props;

    var d = data;

    // TODO: Think about being able to provide a "context" and a context form, as necessary.
    var newItem = {};

    d.push(newItem);

    var maxPage = Math.floor(data.length / pageSize)
    if ((data.length % pageSize) == 0) {
      maxPage--
    }
    var lastItemIDX = d.length -1

    if (definition.multiFormSelector) {
      const multiEditIdx = d.length - 1;
      const targetPath = path + '/' + multiEditIdx;
      this.setState({
        data: d,
        multiEditPath: targetPath,
        multiEditIdx: multiEditIdx,
        singleRecordIdx: lastItemIDX,
        singleRecordTitle: "New Item",
        currentPage: maxPage
      });
    } else {
      this.setState({
        data: d,
        singleRecordIdx: lastItemIDX,
        singleRecordTitle: "New Item",
        currentPage: maxPage
      });
      // Also reset the whole collection

      // check the field definitions for the _append field.
      // can be used to trigger a validation when a line is added
      var fieldDef: any
      for (let preDefined of definition.predefined) {
        if (preDefined.key == "_append") {
          fieldDef = preDefined
        }
      }
        
      if (fieldDef) {
        onChangeAtPath(path, d, fieldDef)
      } else {
        onChangeAtPath(path, d); 
      }      
    }
  };

  handleNestedItemAdd = (dataKey: string) => (event: any) => {
    const { data } = this.state;
    const { definition, path, onChangeAtPath } = this.props;

    var d = data;

    // TODO: Think about being able to provide a "context" and a context form, as necessary.
    var newItem = {};

    d[dataKey].push(newItem);

    var lastItemIDX = d[dataKey].length -1


    if (definition.multiFormSelector) {
      const multiEditIdx = d.length - 1;
      const targetPath = path + '/' + multiEditIdx;
      this.setState({
        data: d,
        singleRecordIdx: lastItemIDX,
      });
    } else {
      this.setState({
        data: d,
        singleRecordIdx: lastItemIDX,
      });
      // Also reset the whole collection

      // check the field definitions for the _append field.
      // can be used to trigger a validation when a line is added
      var fieldDef: any
      // for (let preDefined of definition.predefined) {
      //   if (preDefined.key == "_append") {
      //     fieldDef = preDefined
      //   }
      // }
        
      if (fieldDef) {
        onChangeAtPath(path, d, fieldDef)
      } else {
        onChangeAtPath(path, d); 
      }      
    }
  };

  /*******************************************************************************************
   *
   *                               Summary Actions Handling
   *
   *******************************************************************************************/

  onSelectedItemChange = (item: any, selected: boolean) => {
    item['_selected'] = selected;
    this.forceUpdate();

    if (this.props.onChangeAtPath) {
      this.props.onChangeAtPath(this.props.path, "_selected")
    }
  };

  handleSummaryMenuClick = (event) => {
    this.setState({
      summaryMenuAnchorEl: event.currentTarget,
      summaryMenuOpen: !this.state.summaryMenuOpen
    });
  };

  handleSummaryMenuClose = () => {
    this.setState({ summaryMenuAnchorEl: null, summaryMenuOpen: false });
  };

  handleSummaryMenuItemClick = (action) => () => {
    const { data } = this.state;
    if (data && data.items && data.items.reduce && data.items.length > 0) {
      const selectedItems = data.items.reduce((acc: Array<any>, i: any) => {
        if (i['_selected']) {
          acc.push(i);
        }
        return acc;
      }, []);

      this.setState({
        summaryMenuAnchorEl: null,
        summaryMenuOpen: false,
        summaryOperation: { action: action, items: selectedItems }
      });
    } else {
      this.setState({ summaryMenuAnchorEl: null, summaryMenuOpen: false });
    }
  };

  handleSummarySelectAllClick = () => {
    
    const { data } = this.state;
    const { definition } = this.props;
    data = data.map((i) => {
      i['_selected'] = true;
      return i;
    });
    this.setState({ data }, () => {
      var fieldDef: any
      if (definition) {
        
        for (let preDefined of definition.predefined) {
          if (preDefined.key == "_selected") {
            fieldDef = preDefined
          }
        }
        
        if (!fieldDef) {
          fieldDef = definition.user["_selected"]
        }
      }
      if (this.props.onChangeAtPath) {
        this.props.onChangeAtPath("_selected", true, fieldDef)
      }
    });
  };

  handleSummaryUnselectAllClick = () => {
    
    const { data } = this.state;
    const { definition } = this.props;
    data = data.map((i) => {
      delete i['_selected'];
      return i;
    });
    this.setState({ data }, () => {
      var fieldDef: any
      if (definition) {
        
        for (let preDefined of definition.predefined) {
          if (preDefined.key == "_selected") {
            fieldDef = preDefined
          }
        }
        
        if (!fieldDef) {
          fieldDef = definition.user["_selected"]
        }
      }
      if (this.props.onChangeAtPath) {
        this.props.onChangeAtPath("_selected", false, fieldDef)
      }
    });
  };

  handleSummaryOpComplete = (
    items: Array<any>,
    action: SummaryAction,
    formData: any,
    cancelled: boolean
  ): void => {
    // The summary dialog will not manage internal display state, so if we do not want this rendered we should set the summary operation.
    // To close the dialog, set the summaryOperation to null so the stops rendering.
    //
    // For now, we will just do
    this.setState({ summaryOperation: undefined });
  };

  handleItemToggle = (i: any) => (evt: any) => {
    const { data } = this.state;
    const { definition } = this.props;
    
    i['_selected'] = !i['_selected'];

    // Now set the state and capture the byref change above...offends my functional nature.
    this.setState({ data }, () => {
      var fieldDef: any
      if (definition) {
        
        for (let preDefined of definition.predefined) {
          if (preDefined.key == "_selected") {
            fieldDef = preDefined
          }
        }
        
        if (!fieldDef) {
          fieldDef = definition.user["_selected"]
        }
      }
      
      if (this.props.onChangeAtPath) {
        this.props.onChangeAtPath("_selected", i['_selected'], fieldDef)
      }
    });
  };

  /*****************************************************************************

                          Spawn (Child) Handling

  *****************************************************************************/

  handleMultiEditComplete = (formData: any, cancelled: boolean): void => {
    const { multiEditPath, multiEditIdx, data } = this.state;
    if (!cancelled) {
      // Report the change up
      this.handleChangeAtPath(multiEditPath, formData);
      if (multiEditIdx) {
        data[multiEditIdx] = formData;
      }
    }

    // That done, no need to keep the editor open
    this.setState({ multiEditPath: undefined, data: data });
  };

  renderDeleteButton = (idx: number, canDelete: boolean) => {
    const { classes }: { classes: any } = this.props;  
    var {definition} = this.props
    if (definition.allowsMultiplesShouldConfirmDelete) {
      return (
        <ConfirmButton
          aria-label="delete"
          className={classes.itemDelete}
          disabled={!canDelete}
          confirmColor="danger"
          onButtonConfirm={
            canDelete
              ? this.handleItemDelete(idx)
              : function () { }
          }>
          <i className="fa fas fa-trash" />
        </ConfirmButton>
      )
    } else {
      return (
        <IconButton
          aria-label="delete"
          className={classes.itemDelete}
          disabled={!canDelete}
          onClick={
            canDelete
              ? this.handleItemDelete(idx)
              : function () { }
          }>
          <i className="fa fas fa-trash" />
        </IconButton>
      )
    }
    

  }
  findOption = (dataValue: any, keyFieldDef: any, idx: number, sectionDetails?: any): any => {
    var response = {}
    if (keyFieldDef && keyFieldDef.type) {
      if (dataValue && dataValue != "") {
        switch (keyFieldDef.type) {
          case "Text":
            if (keyFieldDef.options && keyFieldDef.options.length > 0) {
              // get the label not the value?
              for (let option of keyFieldDef.options) {
                if (dataValue && option.value == dataValue) {
                  response["label"] =  option.label,
                  response["value"] = idx
                  break
                }
                
              }
            } else {           
              if(dataValue) {
                response["label"] =  dataValue,
                response["value"] = idx
                break
              }
            }
            // options.push({label: defData[keyName], value: options.length})
            break
          default:
            console.warn("Type not supported")
            response["label"] =  "??",
            response["value"] = idx
        }

      } else {
        response["label"] =  "New Item",
        response["value"] = idx   
      }

      // See if there is a variant
      if (sectionDetails && sectionDetails[idx]) {
        response["variant"] = sectionDetails[idx]
      }
      return response
    }
  };

  handleSingleDefChange = (attribute: string, keyField: PredefinedField, data: any) => (val: any) => {
    const { path, definition } = this.props;

    var subData = data[val][keyField.key]
    var option = this.findOption(subData, keyField, val)
    var label
    if (option.label) {
      label = option.label
    }
    this.setState({singleRecordIdx: val, singleRecordTitle: label})

  };

  getSingleRecordLabel = (idx: number): any => {
    const { definition, singleRecordSelector } = this.props;
    const {data} = this.state

    // var subData = data[definition.key]

    var keyFieldDef 
    if (definition.predefined) {
      // find the def of the key field, for the mode and options. 
      for (let field of definition.predefined) {
        if (field.key && field.key == singleRecordSelector) {
          keyFieldDef = field
        }
      }
    }
    var option = this.findOption(data[idx][keyFieldDef.key], keyFieldDef, idx);
    var label
    if (option && option.label) {
      label = option.label
    }
    return label
      
      


  };

  render() {

    const { classes }: { classes: any } = this.props;
    const {
      definition,
      path,
      itemRenderer,
      policyMessages,
      // sectionConfigIcon,
      adminMode,
      gridSpacing,
      emptySetRenderers,
      readOnly
    } = this.props;
    const {
      status,
      data,
      singleRecordTitle,
      singleRecordIdx,
      multiEditPath,
      multiFormSelector,
      currentPage,
      pageSize
    } = this.state;

    
    if (data === null || data === undefined) {
      return null;
    }

    if (adminMode) {
      if (data.length == 0) {
        data.push({});
      }
    }

    var emptySetMessage: string = undefined
    if (definition && definition.emptySetMesssage) {
      emptySetMessage = definition.emptySetMesssage
    }
    var instructions: Array<any> = []
    if (policyMessages && policyMessages.length > 0) {
      
      policyMessages.forEach((pm: any) => {
        if (pm.path == path) {
          instructions.push(<Typography
              className={this.getPolicyMessageClass(pm)}
              variant="body1"
              gutterBottom
              dangerouslySetInnerHTML={{__html: pm.message}}
            />)
        }
      })
    }

    const maxPage = Math.floor(data.length / pageSize)
    if (currentPage > maxPage) {
      currentPage = maxPage
    }

    let selectedItems: Array<any> = [];


    switch (status) {
      case 'loading':
        // TODO:
        return <LoadingView classes={{}} />;
        break;

      default:
        // We MAY be editing a set that allow multiples and has a multiEditForm selector sepcified
        if (definition.multiFormSelector && multiEditPath) {
          // There IS and form and we are editing it (as signalled by the multiEditPath)
          // the spawn will start off as a copy of the existing item
          let deepClone = JSON.parse(JSON.stringify(data));

          return (
            <div className={classes.fullScreen}>
              <DefinitionFormController
                data={deepClone}
                onFormComplete={this.handleMultiEditComplete}
                formSelector={definition.multiFormSelector}
                fullScreen
              />
            </div>
          );
        }

        const usePaging = definition.usePaging;


        const items = data.reduce(
          (acc: Array<any>, i: any, idx: number): any => {
            // Whether we display it or not, add it to the array if it is selected
            if (i['_selected'] && definition.allowSelection) {
              selectedItems.push(i);
            }
            // We are going to wrap the underlying item with controls for deletion, etc
            let includeInDisplay =
              !usePaging ||
              (idx >= currentPage * pageSize &&
                idx < currentPage * pageSize + pageSize);

            if (includeInDisplay) {
              var canDelete = true;

              const item = itemRenderer(i, idx);
              

              var classNames: Array<string> = [`form-list-item-${idx}`];
              var overlay: any = null;
              var selector: any = null;


              if (i['_selected'] && definition.allowSelection) {
                classNames.push(
                  classes.selectedRow,
                  `form-list-item-selected-row`
                );
                selector = (
                  <i onClick={this.handleItemToggle(i)} className={classes.select + ' fa fa-check-square'} />
                );
              } else {
                if (definition.allowSelection) {
                  classNames.push(
                    classes.unselectedRow,
                    `form-list-item-unselected-row`
                  );
                  // Also put up a semi-opaque overlay as a further signal to the user.
                  overlay = <div onClick={this.handleItemToggle(i)} name="item-overlay" className={classes.overlay}></div>;
                  selector = (
                    <i onClick={this.handleItemToggle(i)} className={classes.unselect + ' fa fa-square'} />
                  );
                } else {
                  classNames.push(classes.unselectableRow);
                }
              }

              if (idx % 2 == 0) {
                classNames.push(classes.itemEven);
              } else {
                classNames.push(classes.itemOdd);
              }
              acc.push(
                <Grid
                  key={idx}
                  className={
                    classes.item +
                    ' ' +
                    classNames.join(' ') +
                    ' ' +
                    `${definition.key}${idx}`
                  }
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}>
                  <div name="item-display-area" style={{ width: "100%", display: 'flex' }}>
                    {item}
                    {multiFormSelector && (
                      <IconButton
                        aria-label="edit"
                        className={classes.itemDelete}
                        onClick={this.handleItemEdit(idx)}>
                        <i className="fa fas fa-note" />
                      </IconButton>
                    )}
                    {!adminMode && !readOnly && this.renderDeleteButton(idx, canDelete)}
                    {overlay}
                    {selector}
                  </div>
                </Grid>
              );
            }
            return acc;
          },
          []
        );

        let actionBar: any = null;
        if (
          !adminMode &&
          (!definition.maxCount || data.length < definition.maxCount)
        ) {
          var actionClass
          if (this.props.singleRecordSelector){
            actionClass = classes.singleItemActionBar
          } else {
            actionClass = classes.itemActionBar
          }
          actionBar = (
            <Grid
              key={'action-bar'}
              className={actionClass}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}>
              <IconButton
                aria-label="add"
                className={classes.itemAdd}
                style={{marginTop: 7}}
                onClick={this.handleItemAdd}>
                <i className="fa fas fa-plus-circle" />
              </IconButton>
            </Grid>
          );
        }

        var emptySet = (
          <EmptySet style={{ color: 'red' }} text={emptySetMessage || "No items have been added"} />
          // <EmptySet classes={{}} text= "No items have been added" />
        );
        if (
          emptySetRenderers &&
          definition.emptySetRenderer &&
          emptySetRenderers[definition.emptySetRenderer]
        ) {
          emptySet = emptySetRenderers[definition.emptySetRenderer]();
        }

        var pager = null;

        if (usePaging && data.length > 0) {
          
          var pageSizeOptions
          if (definition.pageSizeOptions) {
            pageSizeOptions = definition.pageSizeOptions
          }

          pager = (
            <div className={classes.pagerArea}>
              <div className={classes.pager}>
                <Pager
                  page={currentPage}
                  pageSize={pageSize || 10}
                  count={data.length || 0}
                  onChangePage={this.handleChangePage}
                  pageSizeOptions={pageSizeOptions}
                />
              </div>
            </div>
          );
        }

        let singleRecord: any = null;
        if (this.props.singleRecordSelector && this.props.singleRecordSelector != "") {
          // Get the title based on the selector
          var _fd = definition.predefined.find((p)=>{
            return p.key = this.props.singleRecordSelector
          })
          var title:string = " ";
          var selectorText:string = "Select a Record"
          if (_fd && _fd.title){
            title = `Select the ${_fd.title} to display.`
            selectorText = `-- ${_fd.title} --`
          }
          var constructedField = new PredefinedField({})
          constructedField.mode = "Optional"
          constructedField.key = "derivedOptions"
          constructedField.gridAttributes = {
            "xl": 3,
            "lg": 3,
            "md": 4,
            "sm": 6,
            "xs": 12,
          }
          constructedField.title = title
          constructedField.type = "Text"
          constructedField.placeholder = "Select an item"
          constructedField.nullOptionLabel = selectorText



          var pathExt = path + '/';

          var sectionDetails = {}
          if (policyMessages && policyMessages.length > 0) {
            let duplicate = false
            const applicable = policyMessages.reduce((acc, m): Array<any> => {
              let mp = m.path;
              if (mp.indexOf('/') == 0) {
                mp = mp.substring(1);
              }

              let op = path;
              if (op.indexOf('/') == 0) {
                op = op.substring(1);
              }
              // includes instead of equals here, becuase we are looking for sub-messages. 
              if (mp.includes(op)) {
                acc.push(m);
              }

              var secIdx = m.path
              if (m.path.indexOf(pathExt) == 0) {
               secIdx = m.path.replace(pathExt, '');
               if (secIdx.indexOf('/') != -1) {
                // trying to set sectionDetails[idx], 
                // finding idx by grabbing the substring after pathExt, but before the next slash, which should then be a number to be parsed. 
                sectionDetails[parseInt(secIdx.substring(0, secIdx.indexOf('/')))] = "error"
               }
              }

              if (m.path == pathExt + constructedField.key) {
                duplicate = true
              }
      
              return acc;
            }, []);
              
            if (!duplicate) {
              policyMessages.push({
                message: "One or More Records have Errors",
                path: pathExt + constructedField.key,
                severity: 2,
                title: "One or More Records have Errors",
              })
            
            }
          }
          
          // Move to line 1291
          
          var options = []
          var idx = 0
          var keyName = definition.singleRecordSelector

          var keyFieldDef 
          if (definition.predefined) {
            // find the def of the key field, for the mode and options. 
            for (let field of definition.predefined) {
              if (field.key && field.key == definition.singleRecordSelector) {
                keyFieldDef = field
              }
            }
          }
          if (data) {
            // if (data[definition.key]) {
              for (let defData of data) {
                options.push(this.findOption(defData[keyName], keyFieldDef, idx, sectionDetails))
                idx++
              }
            // }
            constructedField.options = options

            // End move line

          }
          const fr = (
            // <div style={{ position: 'relative', width: '100%' }}>
              <Grid
              spacing={gridSpacing || 1}
              className={classes.formAreaOutdent}
              container>
              
            
                <Grid key={'grid_item_' + idx} spacing={1} item xl={3} lg={3} md={4} sm={6} xs={12}>
                <Field
                  path={constructedField.path || (pathExt + constructedField.key)}
                  // value={val}
                  data={data}
                  className={classes.fieldArea}
                  fieldDefinition={constructedField}
                  onCommitChange={this.handleSingleDefChange((constructedField.path || constructedField.key), keyFieldDef, data)}
                  // customRenderers={this.props.customRenderers}
                  policyMessages={policyMessages}
                  showHidden={adminMode}
                  // readOnly={this.props.readOnly}
                  // onAccessRootData={this.props.onAccessRootData}
                />
                {constructedField.mode === 'Hidden' && (
                  <div className={classes.overlay} />
                )}
                
                </Grid>
                <Grid
                  key={"addNewSingleItem"}
                  item
                  xs={6}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={3}>
                  <div className={classes.formArea}>
                    {!readOnly && actionBar}
                  </div>
                </Grid>
              </Grid>
            // </div>
          );

          const item = itemRenderer(data[singleRecordIdx], singleRecordIdx);

          singleRecord =  (
            <Grid key={'grid_item_' + singleRecordIdx} item xl={definition.gridAttributes.xl || 12} lg={definition.gridAttributes.lg || 12} md={definition.gridAttributes.md || 12} sm={definition.gridAttributes.sm || 12} xs={definition.gridAttributes.xs || 12} classname={classes.formAreaOutdent}>
            <div style={definition.styleAttributes} >
              {/* <Typography variant="h1" className={classes.subSectionTitle}>
                {"title"}
              </Typography> */}

              {definition.instructions && <FormHelperText><div dangerouslySetInnerHTML={{ __html: definition.instructions }}></div></FormHelperText>}
              {fr}
              <Typography variant="h2" className={classes.subSectionTitle}>
                {singleRecordTitle}
              </Typography>
              {item}
              </div>
            </Grid>
          );
        }



        if (definition.allowSelection && data.length > 0) {
          // This section uses a switch, since I started using the word `items` in there, so wanted to be able to have appropraite grammar and ploralization.
          var selectionActionArea: any = null;
          var selectionCountText: string = ""
          switch (selectedItems.length) {
            case 0:
              selectionCountText = "(0 of " + data.length + " selected)"
              break;

            case 1:
              selectionCountText = "(1 of " + data.length + " selected)"
              break;

            default:
              selectionCountText = "(" + selectedItems.length + " of " + data.length + " selected)"
          }

          selectionActionArea = (
            <div className={classes.selectionActionArea}>
              <div className={classes.allSelectors}>
                <div className={classes.selectAll} onClick={this.handleSummarySelectAllClick} >
                  <i className={"fa fa-check-square " + classes.selector} /> Select All
                </div>
                <div className={classes.unselectAll} onClick={this.handleSummaryUnselectAllClick} >
                  <i className={"fa fa-square " + classes.selector} /> Unselect All
                </div>
              </div>
              <div className={classes.selectionCount}>
                {selectionCountText}
              </div>
            </div>
          )
        }
        
        classes.instructions
        var instructionClass = classes.instructions
        if (!instructions) {
          instructionClass = classes.noInstructions
        }
        return (
          <div className={classes.container + ' ' + definition.key}>
            <div className={instructionClass}>
              {instructions}
            </div>
            <Grid spacing={gridSpacing || 1} container>
              <div
                style={{ width: "100%" }}
                className="item-list-paging-container">
                {selectionActionArea}
                {!this.props.singleRecordSelector && items.length > 0  && items}
                {this.props.singleRecordSelector != "" && singleRecord}
                {items.length == 0 && emptySet}
                {pager}
              </div>
            </Grid>
            {!readOnly && !this.props.singleRecordSelector && actionBar}
          </div>
        );
    }
  }
}

export default withStyles(styles)(FormItemList);
